import { CATEGORY_COLORS } from '../../constants/categoryColors';
import { getLogTypeByCategory } from '../../constants/logTypeRegistry';

export const TIMELINE_PERIOD_TINTS = {
  morning: {
    bg: '#FFF9E6',
    border: '#FDE68A',
  },
  afternoon: {
    bg: '#F0FDF4',
    border: '#BBF7D0',
  },
  evening: {
    bg: '#EFF6FF',
    border: '#BFDBFE',
  },
  general: {
    bg: '#FAF5FF',
    border: '#E9D5FF',
  },
};

const DEFAULT_CATEGORY_COLORS =
  CATEGORY_COLORS.dailyLog ||
  CATEGORY_COLORS.behavior ||
  CATEGORY_COLORS.health ||
  CATEGORY_COLORS.mood ||
  CATEGORY_COLORS.milestone || {
    bg: '#F5F5F5',
    text: '#555555',
    border: '#AAAAAA',
    dot: '#AAAAAA',
  };

export const getCareLogTone = (category) => (
  CATEGORY_COLORS[category] ||
  (category === 'note' ? CATEGORY_COLORS.dailyLog : null) ||
  (category === 'log' ? CATEGORY_COLORS.dailyLog : null) ||
  DEFAULT_CATEGORY_COLORS
);

export const getCareLogCategoryMeta = (category) => {
  const normalizedCategory = String(category || 'log').trim().toLowerCase();
  const logType = getLogTypeByCategory(normalizedCategory)
    || getLogTypeByCategory(normalizedCategory === 'note' ? 'log' : normalizedCategory)
    || getLogTypeByCategory('log');

  return {
    category: normalizedCategory,
    tone: getCareLogTone(normalizedCategory),
    logType,
    label: logType?.displayLabel || logType?.filterLabel || normalizedCategory || 'Daily Log',
    icon: logType?.iconComponent ? null : (logType?.icon || null),
    iconComponent: logType?.iconComponent || null,
  };
};

export const getTimelinePeriodTint = (period = 'general') => (
  TIMELINE_PERIOD_TINTS[String(period || 'general').trim().toLowerCase()] ||
  TIMELINE_PERIOD_TINTS.general
);

export { DEFAULT_CATEGORY_COLORS };
